export default __webpack_public_path__ + "static/media/waste-water.f94f879f.png";